export const isValidCanadianPostalCode = (postalCode) => {
  /* Old validation
  const pattern = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;*/
  // New validation
   const pattern = /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ ]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/;
  return pattern.test(postalCode.trim());
};

//examples
    // "K1A 0B1",   // Ottawa, ON - Canada Post HQ
    // "V6B 4N6",   // Vancouver, BC
    // "M5V 3L9",   // Toronto, ON
    // "T2P 3G7",   // Calgary, AB
    // "H2Z 1A7",   // Montreal, QC
    // "B3J 2X1",   // Halifax, NS
    // "R3C 4T3",   // Winnipeg, MB
    // "L5N2E1",    // No space - still valid
    // "G1R4P5"     // Quebec City, QC